import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PIFooterComponent } from './PIFooter.component';

@NgModule({
    imports: [CommonModule],
    declarations: [PIFooterComponent],
    exports: [PIFooterComponent],
    providers: []
})
export class PIFooterModule {}
